import React from 'react';

export default class MenuButton extends React.Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        return (<React.Fragment><button className={this.props.classesContainer}>{this.props.containerInnerText}
        <br /><span className={this.props.classesSpan}>{this.props.spanInnerText}</span></button>
        </React.Fragment>)
    }
}
